const bool = (value: string | undefined): boolean => value === "true";

export const isHotspot = bool(process.env.VUE_APP_HOTSPOT);
export const isWiki = bool(process.env.VUE_APP_WIKI);
